import axios from "axios";
import mainConfig from "/config";
const account = mainConfig.endpoint + "account"

const api = {
    getUserByUsername(username) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__get_user_by_username__');
        aFormData.append("username", username);

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp)

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                });
        });
    },

    updateProfile(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__update_profile__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(mainConfig.endpoint + "account", aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getAllUsers(token, currentPage, perPage) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__get_all_users__');
        aFormData.append("perPage", perPage);
        aFormData.append("currentPage", currentPage);

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    updateUser(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__updated_user__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getAllRoomsForAdmin(token, currentPage, perPage) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__get_all_rooms_for_admin__');
        aFormData.append("perPage", perPage);
        aFormData.append("currentPage", currentPage);

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeRoomStatus(uid, status, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__change_room_status__');
        aFormData.append("data", JSON.stringify({
            uid: uid,
            status: status
        }));

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    getAllMessagesForAdmin(token, currentPage, perPage) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__get_all_messages_for_admin__');
        aFormData.append("perPage", perPage);
        aFormData.append("currentPage", currentPage);

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

    changeMessageStatus(uid, status, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("users_methods", '__change_message_status__');
        aFormData.append("data", JSON.stringify({
            uid: uid,
            status: status
        }));

        return new Promise((resolve, reject) => {
            axios
                .post(account, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err);
                });
        });
    },

}


export default api